import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { ResultsData } from "../../state/Brands/ResultsData";
import { DEFAULT_LIMIT } from '../../state/SearchManager/FormData';
import { BrandListResponse } from "../../../integrated-client/models";

const updateResultsData: Reducer<ResultsData> = (state: ResultsData = new ResultsData(), action: Action<ActionType, any>) => {
  let updatedItemsList = action.data,
    showMore = false;
  switch (action.type) {
    case ActionType.BRANDS_DATA_FETCHED: {
      const response = action.data as BrandListResponse;
      let items = response.items ?? [];
      if (items.length > DEFAULT_LIMIT) {
        items = items.slice(0, DEFAULT_LIMIT);
        showMore = true;
      }
      return { ...state, items, showMore, total: response.totalRecords ?? 0 };
    }
    case ActionType.BRANDS_DATA_UPDATED:
      if (updatedItemsList.length > DEFAULT_LIMIT) {
        updatedItemsList = updatedItemsList.slice(0, DEFAULT_LIMIT);
        showMore = true;
      }
      return { ...state, items: [...state.items, ...updatedItemsList], showMore };
    case ActionType.BRANDS_DATA_REFRESHED:
      if (updatedItemsList.length - 1 > state.items.length) {
        showMore = true;
      }
      return { ...state, items: updatedItemsList, showMore };
    default:
      return state;
  }
};

export default updateResultsData;